import { Notification, Loading, MessageBox } from "element-ui";  // Introduce

export const capitalize = text => text.slice(0,1).toUpperCase() + text.slice(1).toLowerCase();
export const getTitleCase = text => text.split(" ").map(capitalize).join(" ");
export const snakeToTitleCase = text => text.split("_").map(capitalize).join(" ");

export const currencyToNumber = currency => Number(currency.replace("NPR.").replace("Rs.").trim().split(",").join(""))
export const formatNumberNepaliStyle = (value, {maxPrecision=3, minPrecision=0}={}) =>
{
    const formatter = new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: minPrecision,
        maximumFractionDigits: maxPrecision,
    })
    return formatter.format(value);
}; 
export const formatCurrency = (value, {withDecimals=true}={}) =>
{
    const precisionOptions = withDecimals ? {minPrecision: 2, maxPrecision: 2} : {minPrecision: 0, maxPrecision: 2};
    return `NPR ${formatNumberNepaliStyle(value, precisionOptions)}`
};
export const formatLatLng = val => `${val.toFixed(6)}°`
export const latLngToNumber = val => Number(val.replace('°'))

export const showError = (title, message, options={}) =>
{
    return Notification.error({
        title: getTitleCase(title),
        message,
        customClass: 'error',
        position: 'bottom-left',
        ...options
    });
};

export const showWarning = (title, message, options={}) =>
{
    return Notification.warning({
        title: getTitleCase(title),
        message,
        customClass: 'warning',
        position: 'bottom-left',
        ...options,
    });
};

export const showSuccess = (title, message, options={}) =>
{
    return Notification.success({
        title: getTitleCase(title),
        customClass: 'success',
        message,
        position: 'bottom-left',
        ...options,
    });
};

export const showInfo = (title, message, options={}) =>
{
    return Notification.info({
        title: getTitleCase(title),
        customClass: 'info',
        message,
        position: 'bottom-left',
        ...options,
    });
};

let loadingModal = null;

export const showLoading = (text='loading..') =>
{
    // it's a singleton. don't have to worry about multiple instance & creating memory leak
    loadingModal = Loading.service({
        fullscreen: true,
        lock: true,
        text,
        background: '#000a',
    });
}

export const hideLoading = () =>
{
    console.assert(loadingModal, "Trying to hide a modal before it's shown");
    loadingModal && loadingModal.close();
}

export const confirm = ({
    title="Confirmation",
    msg="Are you sure?",
    onSuccess=()=>{},
    onFailure=()=>{},
}) =>
{
    MessageBox.confirm(msg, title).then(onSuccess).catch(onFailure);
};